module.exports = __webpack_public_path__ + "img/3_4.d6a5ab53.png";